import { render, staticRenderFns } from "./question-list.vue?vue&type=template&id=209f92f1"
import script from "./question-list.vue?vue&type=script&lang=js"
export * from "./question-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports